import { useMutation, useQuery } from '@tanstack/react-query';
import { makeRequest } from 'features/entry-form-v2/data/makeRequest';
import { CodelistRecord, CodelistRecordKey } from '../domain/codelistRecordSchema';

export type SearchRecordsResponse = {
	records: (CodelistRecord & {
		originalEntryId: string;
		id: string;
		lastModifiedDate: string;
	})[];
};

export type SearchRecordsFilter = {
	key: CodelistRecordKey;
	value: string;
	match?: 'EXACT_CASE_INSENSITIVE';
};

export const useSearchRecordsMutation = (params: { projectId: string }) => {
	return useMutation({
		mutationFn: (args: { filters: SearchRecordsFilter[] }) =>
			makeRequest<SearchRecordsResponse>({
				method: 'searchRecords',
				service: 'cde',
				data: {
					projectId: params.projectId,
					filters: args.filters
				}
			})
	});
};

export const useSearchRecordsQuery = (
	params: {
		projectId: string;
		filters: SearchRecordsFilter[];
	},
	opts?: {
		enabled?: boolean;
	}
) => {
	return useQuery({
		queryKey: ['codelist', params.projectId, params.filters],
		...opts,
		queryFn: () =>
			makeRequest<SearchRecordsResponse>({
				method: 'searchRecords',
				service: 'cde',
				data: {
					projectId: params.projectId,
					filters: params.filters
				}
			})
	});
};
